import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-edit",
  "use": "default-edit-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"default-edit\"><path d=\"M21.582 0l6.416 6.643-2.821 2.723.044.045L9.259 24.824l.741.74-1.77.254-.265.257-.186-.192L0 27.003l1.422-10L2.721 18.3 16.979 4.53l-.043-.044L21.582 0zM2.798 21.12l-.51 3.592 3.592-.517-3.082-3.075zM18.262 5.859L4.16 19.479l3.85 3.986 14.1-13.62-3.849-3.986zm3.276-3.248l-1.493 1.44 3.849 3.987 1.493-1.441-3.85-3.986z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol